export function KeyboardControllerPadding({
  maxHeight: _,
}: {
  maxHeight?: number
}) {
  return null
}
